import React from 'react';
import { Button } from '../Button/Button';
import './heroSection.scss';

export const HeroSection = () => {
  return (
    <div className="heroSection">
      <h1>CONSULTVISION partner pro komplexní IT řešení na míru</h1>
      <Button btnName="Kontaktujte nás" />
    </div>
  );
};
